<template>
    <div class="public-profile-wrapper">
        <div class="surface-section min-h-screen ">
            <div class="flex flex-column  lg:flex-row gap-4 mt-4 justify-content-center">
                <div class="w-full">
                    <div class="mb-4">
                        <h3 class="Paragraph-Medium font-semibold mb-4">Personal Information</h3>
                        <div class="mb-4">
                            <span class="Paragraph-Medium  block mb-2">I teach in -</span>
                            <ul class="list-none   ml-5">
                                <li v-for="(lang, i) in profileDetails?.teachingLanguage" :key="i">{{ cleanupLables(lang) }}</li>
                            </ul>
                        </div>
                        <div class="mb-4">
                            <span class="Paragraph-Medium  block mb-2">I do classes in -</span>
                            <ul class="list-none  ml-5">
                                <!-- <li v-for="(method, i) in classTypes" :key="i">{{ method }}</li> -->
                                <li>{{ profileDetails?.classMode ? formattedClassMode : 'Not specified' }}</li>
                            </ul>
                        </div>
                        <div class="mb-4">
                            <span class="Paragraph-Medium  block mb-2">Teaching time availability -</span>
                            <ul class="list-none  ml-5">
                                <li v-for="(time, i) in profileDetails?.teachingAvailability" :key="i">{{ cleanupLables(time) }}</li>
                            </ul>
                        </div>
                        <div class="mb-4">
                            <span class="Paragraph-Medium  block mb-2">Nationality -</span>
                            <ul class="list-none  ml-5">
                                <li>{{ profileDetails?.nationality || 'Sri Lanka' }}</li>
                            </ul>
                        </div>
                        <div class="mb-4">
                            <span class="Paragraph-Medium mb-1">Verifications -</span>
                            <ul class="list-none  ml-5">
                                <li>Email: <span class="text-green-500 Label">{{ profileDetails?.emailVerified ?
                                    "Verified" : "not verfied" }}</span></li>
                                <li>Identity: <span class="text-green-500 Label">{{ profileDetails?.finalReviewByAdmins
                                    ? "Verified" : "not verfied" }}</span></li>
                                <li>Driver’s license: <span class="text-green-500 Label">{{
                                    profileDetails?.drivingLicenseURL ? "Verified" : "not verfied" }}</span></li>
                            </ul>
                        </div>
                        <div class="mb-4">
                            <span class="Paragraph-Medium block mb-2">Education -</span>
                            <ul class="list-none  ml-5">
                                <li v-for="(edu, i) in profileDetails?.highestEducation" :key="'edu-' + i">{{ edu?.education }}</li>
                                <li v-for="(qual, i) in profileDetails?.teachingQualifications" :key="'qual-' + i">{{ qual?.qualification }}</li>
                                <li v-if="(!profileDetails?.highestEducation || profileDetails.highestEducation.length === 0) && (!profileDetails?.teachingQualifications || profileDetails.teachingQualifications.length === 0)">Not specified</li>
                            </ul>
                        </div>
                        <div>
                            <span class="Paragraph-Medium block mb-2">Notable Achievements -</span>
                            <ul class="list-none  ml-5">
                                <li v-for="(ach, i) in profileDetails?.notableAchievements" :key="i">{{ ach?.achievement }}</li>
                                <li v-if="!profileDetails?.notableAchievements || profileDetails.notableAchievements.length === 0">None listed</li>
                            </ul>
                        </div>

                    </div>
                </div>
                <Divider layout="vertical" />
                <div class="w-full mb-4">
                    <div class="mb-6">
                        <h3 class="font-semibold Paragraph-Medium mb-3">About Me</h3>
                        <p class="line-height-3 Label m-0">
                            {{ profileDetails?.tutorBio || "Not provided" }}
                        </p>
                    </div>
                    <Divider class="w-full" />
                    <div class="mb-6">
                        <h3 class="Paragraph-Medium mb-3">Grades and subjects I teach</h3>
                        <div v-if="!profileDetails?.teachingLevels || profileDetails?.teachingLevels.length === 0">
                            <span class="Label">No grades or subjects listed.</span>
                        </div>
                        <div v-else class="teaching-container flex flex-column gap-4">
                            <div v-for="(group, gIndex) in groupedTeachingLevels" :key="gIndex" class="teaching-grade-block">
                                <div class="grade-header-row mb-1 border-bottom-1 border-gray-100 pb-1">
                                    <span class="Label font-semibold">{{ cleanupLables(group.grade) }}</span>
                                    <span class="text-xs text-500 font-medium text-right">Individual Class</span>
                                    <span class="text-xs text-500 font-medium text-right">Group Class</span>
                                </div>
                                <div class="flex flex-column pl-2 md:pl-4 mt-1">
                                    <div v-for="entry in group.entries" :key="entry.subject" class="subject-row">
                                        <span class="Label">{{ cleanupLables(entry.subject) }}</span>
                                        <span class="Label block w-full" :class="entry.individualClass?.available ? 'text-right' : 'text-right pr-5'">
                                            {{ entry.individualClass?.available ? formatPrice(entry.individualClass.charge) : '—' }}
                                        </span>
                                        <span class="Label block w-full" :class="entry.groupClass?.available ? 'text-right' : 'text-right pr-5'">
                                            {{ entry.groupClass?.available ? formatPrice(entry.groupClass.charge) : '—' }}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <Divider class="w-full" />
                    <div class="mb-6">
                        <h3 class=" Paragraph-Medium mb-3">Previous Experiences</h3>
                        <div class="flex flex-column gap-2">
                            <div v-for="(exp, index) in profileDetails?.experience" :key="index" class="flex">
                                <span class="flex-1 Label">{{ exp?.institution || "N/A" }}</span>
                                <span class="w-15 text-left Label">{{ exp?.yearsOfExperience || "N/A" }} years</span>
                            </div>
                            <div v-if="!profileDetails?.experience || profileDetails.experience.length === 0">
                                <span class="Label">No previous experience listed.</span>
                            </div>
                        </div>
                    </div>
                    <Divider class="w-full" />
                    <div class="mb-6">
                        <h3 class="Paragraph-Medium mb-3">What my students say</h3>
                        <div class="flex align-items-center gap-2 mb-1">
                            <div class="flex gap-1">
                                <i v-for="n in 5" :key="n" class="pi"
                                    :class="n <= Math.round(averageRating) ? 'pi-star-fill text-yellow-400' : 'pi-star text-400'"></i>
                            </div>
                            <span class="font-semibold">{{ averageRating.toFixed(1) }}</span>
                        </div>
                        <div class="text-sm text-gray-500 mb-4">{{ reviewCount }} {{ reviewCount === 1 ? 'review' : 'reviews' }} for this profile</div>

                        <div v-if="publishedFeedbacks.length" class="flex flex-column gap-4">
                            <div v-for="(feedback, index) in publishedFeedbacks" :key="index" class="col-12 p-2">
                                <div class="surface-section border-round shadow-1 p-4 flex flex-column gap-2 h-full">
                                    <div class="flex justify-content-between align-items-start">
                                        <div class="flex gap-3 align-items-center flex-1">
                                            <img :src="feedback.studentProfilePhotoURL ? profileImageUrl(feedback.studentProfilePhotoURL) : blankProfile"
                                                alt="Student profile photo"
                                                class="h-3rem w-3rem border-circle flex-shrink-0 student-feedback-avatar" />
                                            <div class="flex flex-column flex-1">
                                                <span
                                                    class="font-semibold whitespace-nowrap overflow-hidden text-overflow-ellipsis">
                                                    {{ feedback.studentName }}
                                                </span>
                                                <span
                                                    class="text-color-secondary text-sm mt-1 whitespace-nowrap overflow-hidden text-overflow-ellipsis">
                                                    {{ cleanupLables(feedback.studentGrade) }}
                                                </span>
                                            </div>
                                        </div>
                                        <div class="flex flex-column align-items-end flex-none">
                                            <div class="flex gap-1">
                                                <i v-for="n in 5" :key="n" class="pi pi-star"
                                                    :class="n <= feedback.rating ? 'text-yellow-500' : 'text-400'"></i>
                                            </div>
                                            <span class="text-color-secondary text-sm mt-1">{{feedback.created_at}}</span>
                                        </div>
                                    </div>
                                    <Divider class="w-full" />
                                    <div class="Label">Review for - {{ feedback.tutorName }}</div>
                                    <div class="text-color-secondary text-sm">{{ feedback.review }}</div>
                                </div>
                            </div>
                        </div>
                        <div v-else class="surface-section border-round shadow-1 p-4">
                            <div class="Label">No student feedback to display yet.</div>
                        </div>
                        <div class="flex justify-content-center mt-3">
                            <Paginator v-if="reviewsPagination && reviewsPagination.totalPages > 1"
                                :rows="reviewsPagination.limit" :totalRecords="reviewsPagination.totalReviews"
                                :first="(reviewsPagination.page - 1) * reviewsPagination.limit"
                                @page="onPageChange" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { defineProps, defineEmits, computed, ref } from "vue";
import Divider from "primevue/divider";
import Paginator from "primevue/paginator";
import blankProfile from '@/assets/blank-profile.png';
import { cleanupLables } from "@/utils/cleanups";
import { generateSignedUrl } from '@/api/storage';
const props = defineProps({
    profileDetails: null,
    feedbacks: null,
    reviewsPagination: {
        type: Object,
        required: false,
        default: () => ({ totalReviews: 0, page: 1, totalPages: 1, limit: 5 })
    }
})

const emit = defineEmits(['change-review-page']);

const onPageChange = (event) => {
    // PrimeVue Paginator pages are zero-based; the API is one-based.
    emit('change-review-page', event.page + 1);
};

const imageUrls = ref({});
const profileImageUrl = (filePath) => {
    if (!filePath || filePath === 'Service is not available in local environment') return blankProfile;
    if (imageUrls.value[filePath]) return imageUrls.value[filePath];

    generateSignedUrl(filePath)
        .then(url => {
            imageUrls.value[filePath] = url || blankProfile;
        })
        .catch(() => {
            imageUrls.value[filePath] = blankProfile;
        });
    return imageUrls.value[filePath] || blankProfile;
};

const publishedFeedbacks = computed(() => {
    const tutorId = props.profileDetails?._id;
    return (props.feedbacks ?? []).filter(
        f => f.published && (!tutorId || f.tutorId === tutorId)
    );
});

// Overall stats come from the tutor-level aggregates (same fields used in the
// tutor list), so they reflect ALL reviews, not just the current page.
const reviewCount = computed(() =>
    Number(props.profileDetails?.reviewCount ?? props.reviewsPagination?.totalReviews ?? publishedFeedbacks.value.length)
);

const averageRating = computed(() => {
    if (props.profileDetails?.averageRating != null) return Number(props.profileDetails.averageRating) || 0;
    // Fallback: mean of the loaded page if the aggregate isn't provided.
    const list = publishedFeedbacks.value;
    if (!list.length) return 0;
    return list.reduce((sum, f) => sum + (Number(f.rating) || 0), 0) / list.length;
});

const groupedTeachingLevels = computed(() => {
    if (!props.profileDetails?.teachingLevels) return [];
    const map = {};
    props.profileDetails.teachingLevels.forEach(entry => {
        if (!map[entry.grade]) map[entry.grade] = { grade: entry.grade, entries: [] };
        map[entry.grade].entries.push(entry);
    });
    return Object.values(map);
});

const formatPrice = (amount) => {
    if (amount == null) return '—';
    return `LKR. ${new Intl.NumberFormat('en-LK', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(amount)}`;
};

const formattedClassMode = computed(() => {
    const mode = props.profileDetails?.classMode;
    if (mode === 'both') {
        return 'Physical & Online';
    }
    if (!mode || typeof mode !== 'string') {
        return '';
    }
    return mode.charAt(0).toUpperCase() + mode.slice(1);
});

</script>

<style scoped>
.banner-responsive {
    height: 500px;
    background-color: transparent;
}

.overlap-section {
    position: relative;
    margin-top: -4rem;
    background: transparent;
    padding: 0 1rem;
    margin-left: auto;
    margin-right: auto;
}

.profile-image {
    width: 160px;
    height: 160px;
    border-radius: 50%;
    border: 4px solid white;
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.15);
    object-fit: cover;
    margin-top: -10px;
}

.student-feedback-avatar {
    object-fit: cover;
}

.profile-info {
    display: flex;
    flex-direction: column;
    margin-top: 40px;
}

.orange-button-small {
    margin-top: 40px;
}

@media (max-width: 767px) {
    .overlap-section {
        margin-top: -3rem;
        padding: 0 0.5rem;
    }

    .profile-image {
        width: 120px;
        height: 120px;
        margin-top: -5px;
    }

    .profile-info {
        margin-top: 15px;
    }

    .orange-button-small {
        margin-top: 15px;
    }

    .banner-responsive {
        height: 350px;
        object-fit: contain !important;
    }
}

/* Tablet Styles */
@media (min-width: 768px) and (max-width: 1023px) {
    .overlap-section {
        margin-top: -3.5rem;
    }

    .profile-image {
        width: 140px;
        height: 140px;
    }
}

.teaching-container {
    width: 100%;
}

.teaching-grade-block {
    width: 100%;
    margin-bottom: 1rem;
}

.grade-header-row,
.subject-row {
    display: grid;
    grid-template-columns: 1fr 9rem 9rem;
    gap: 0.5rem;
    align-items: center;
    padding: 0.2rem 0;
}

.subject-row {
    border-bottom: 1px dashed var(--p-surface-border, #f3f4f6);
    padding: 0.3rem 0;
}

.subject-row:last-child {
    border-bottom: none;
}

@media (max-width: 600px) {
    .grade-header-row,
    .subject-row {
        grid-template-columns: 1fr 7rem 7rem;
        gap: 0.25rem;
    }
}
</style>